<template>
  <!-- Crm Dialog -->
  <r-dialog id="crm-dialog" :value="value" @input="onDialogClose">
    <component
      ref="releIntegrationComponent"
      v-if="type"
      :is="componentName"
      :mode="mode"
      :authType="authType"
      @close="onDialogClose"
      @on-api-key-choice="$emit('on-api-key')"
      @on-oauth-choice="$emit('on-oauth')"
    />
  </r-dialog>
</template>

<script>
export default {
  // set props
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: "create"
    },
    authType: {
      type: String,
      default: ""
    }
  },

  // computed
  computed: {
    /**
     * returns component name
     */
    componentName() {
      return `rele-${this.type}-connection`
    }
  },

  methods: {
    /**
     * On dialog close
     */
    onDialogClose() {
      this.$emit("on-close")
      this.$emit("input")
    }
  }
}
</script>
